<template>
  <modal
    name="MessageDialog"
    transition="nice-modal-fade"
    :pivotY="0.5"
    :classes="['MessageDialog']"
    :clickToClose="false"
    @before-open="beforeOpen"
    @opened="isShow = true"
    @closed="isShow = false"
  >
    <div class="rootDom" :style="rootStyle">
      <div class="titleDom">
        <span class="title">{{ title }}</span>
        <div class="close-btn" v-if="showCloseBtn" @click="hide('Close')">
          <i class="icon-popup-close"></i>
        </div>
      </div>
      <div class="contentDom">
        <span
          v-if="contentHtml"
          class="content"
          :style="contentStyle"
          v-html="content"
        ></span>
        <span v-else class="content" :style="contentStyle">{{ content }}</span>
        <div class="btnDom" v-if="btns && btns.length > 0">
          <div
            v-for="(btn, index) in btns"
            :key="index"
            class="button button-Customize"
            :class="[btn.className]"
            @click="handBtnClick(btn.type)"
          >
            {{ btn.content }}
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "MessageDialog",
  data() {
    return {
      waiting: false,
      isShow: false,

      title: "", //标题
      content: "", //内容
      contentStyle: {},
      contentHtml: false,
      rootStyle: {
        width: 478 + 'px',
        paddingLeft: 40 + 'px',
        paddingRight: 40 + 'px',
        height: 'auto',
        minHeight: '236px'
      },
      btns: [], //按钮
      showCloseBtn: false, //是否显示关闭按钮
      resultHandler: null, //事件处理函数

      pre_defined_btns: {
        Ok: { type: "Ok", content: "确定", className: "button-Ok" },
        Cancel: { type: "Cancel", content: "取消", className: "button-Cancel" },
        Delete: { type: "Delete", content: "删除", className: "button-Delete" }
      }
    };
  },
  props: {},
  components: {},
  methods: {
    beforeOpen(ev) {
      this.init();

      this.title = ev.params.title;
      this.content = ev.params.content;
      this.contentStyle = ev.params.contentStyle || {
        textAlign: 'left'
      };
      this.contentHtml = ev.params.contentHtml;
      let inputBtns = ev.params.btns || [];

      for (const key in inputBtns) {
        let btn = inputBtns[key];
        if (typeof btn == "object") {
          if (btn.hasOwnProperty("type") && btn.hasOwnProperty("content")) {
            // btn.className = "button-Customize";
            this.btns.push(btn);
          }
        } else if (typeof btn == "string") {
          if (this.pre_defined_btns[btn]) {
            this.btns.push(this.pre_defined_btns[btn]);
          } else if (btn === "Close") {
            this.showCloseBtn = true;
          }
        }
      }
      if (typeof ev.params.resultHandler == "function") {
        this.resultHandler = ev.params.resultHandler;
      }
    },
    init() {
      this.title = ""; //标题
      this.content = ""; //内容
      this.btns = []; //按钮
      this.showCloseBtn = false; //是否显示关闭按钮
      this.resultHandler = null; //事件处理函数
    },
    handBtnClick(type) {
      this.hide(type);
    },
    hide(type) {
      this.$modal.hide("MessageDialog");
      if (this.resultHandler) {
        this.resultHandler(type);
      }
      this.init();
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang="scss">
.v--modal-overlay {
  z-index: 99999;
}
.rootDom {
  position: relative;
  width: 420px;
  height: 210px;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;

  padding: 0 17px 40px 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .titleDom {
    position: relative;
    height: 40px;
    width: 100%;
    .title {
      display: inline-block;
      position: absolute;
      // left: 0;
      font-size: 16px;
      line-height: 40px;
      text-align: left;
    }
    .close-btn {
      position: absolute;
      top: 14px;
      right: 0px;
      cursor: pointer;
    }
  }
  .contentDom {
    flex-grow: 1;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content {
      display: inline-block;
      color: #333333;
      font-size: 14px;
      line-height: 30px;
    }
    .btnDom {
      margin-top: 40px;
      height: 40px;
      width: 362px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-shrink: 1;
      .button {
        width: 160px;
        height: 40px;
        border-radius: 8px;

        text-align: center;
        line-height: 40px;
        cursor: pointer;
        flex-shrink: 1;
      }
      .button-Ok {
        color: #fefefe;
        background-color: #5778fb;
        border-color: #5778fb;
      }
      .button-Customize {
        color: #fefefe;
        background-color: #5778fb;
        border-color: #5778fb;
      }
      .button-Cancel {
        background-color: #eaeaf6;
        border-color: #eaeaf6;
        color: #333;
      }
      .button-Delete {
        background-color: #ea3d45;
        border-color: #ea3d45;
        color: #fefefe;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/MessageDialog.vue